const footer = {
  footer: {
    imageTitle: 'Visite o site da Enphase Energy',
    privacy: 'Privacidade',
    terms: 'Termos',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Todos os direitos reservados.',
    language: 'Idioma',
    production_ct: {
      verify_ct: "Verificar o TC",
      checlist_nodata: "Dados insuficientes do medidor disponíveis para realizar essa verificação",
      production_meter_verification: "Verificação do medidor de produção",
      serial_no: "N.º de série",
      polarity_check: "Verificação de polaridade",
      polarity_check_failed: "A verificação de polaridade falhou",
      ct_missing_branch_check: "Verificar se o TC tem circuitos de ramificação em falta",
      polarity_check_passed: "A verificação de polaridade foi aprovada",
      ct_no_missing_branch_circuit: "O TC não tem circuitos de ramificação em falta",
      incorrect_direction_or_phase_message: "A direção ou fase do TC de produção pode estar incorreta",
      hide_details: "Ocultar os detalhes",
      check_try_again: "Verifique o seguinte e tente novamente",
      pv_on_for_5_min: "Certifique-se de que o circuito FV está ACIONADO e de que está ativo há pelo menos 5 minutos",
      l1_wires_production_ct_message: "Verifique se apenas os cabos L1 passam pelo TC de produção e se o fluxo de produção está na direção da seta do TC do FV para o disjuntor",
      blue_white_wires_position_message: "Certifique-se de que os cabos de cor azul e branca estão ligados às posições corretas no bloco terminal do Gateway",
      wires_include_pv_generation_not_load_storage: "Certifique-se de que os cabos a passar pelo TC de produção incluem apenas a geração FV (e não qualquer carga ou armazenagem)",
      l1_a_correct_phase_message: "Assegure-se de que a fase correta, ou seja L1(a), está a passar pelo TC de produção",
      l1_phase_consistency_check_message: "Verifique a consistência da fase L1 usando um medidor digital e assegure-se de que os circuitos L1 do FV e L1 do Gateway estão na mesma fase",
      missing_branch_warning: "O TC de produção pode ter circuitos de ramificação em falta",
      test_only_valid_for_sunshine_hours: "Este teste só é válido para horas de sol",
      reading_lower_than_expected: "As leituras de produção estão abaixo do esperado. Verifique o seguinte, depois toque e tente novamente",
      wires_include_all_pv_generation: "Certifique-se de que o cabo que passa pelo TC de produção incluiu todos os circuitos de geração FV",
      branch_circuit_reverse_check: "Certifique-se de que nenhum dos circuitos das ramificações passa pelo TC no sentido inverso",
      storage_load_circuits_through_production_ct: "Certifique-se de que há circuitos de armazenagem ou de carga a passar pelo CT de produção",
      show_details: "Exibir os detalhes",
      verify_ct_not_supported_for_device: "A verificação do medidor não é possível neste dispositivo",
      verify_ct_timeStamp: "Verificado",
      verify_ct_systemID: "ID do sistema",
      prodct_reversepolarity_text: "A direção ou fase do TC de produção pode estar incorreta",
      prodct_reverse_polarity_btn: "Inverter a polaridade",
      verify_ct_timeout: "Pedir Timed Out. Por favor, tente novamente"

    }
  }
};

export default footer;